<template>
  <div class="form-grid">
    <div class="form-column">
      <div class="form-row">
        <div class="form-group">
          <label>First Name:</label>
          <div class="input-group">
            <i class="fa-solid fa-user"></i>
            <input
              :value="doctor.firstname"
              @input="updateField('firstname', $event.target.value)"
              type="text"
              placeholder="Enter first name"
            />
          </div>
          <p v-if="errors.firstname" class="error">
            {{ errors.firstname }}
          </p>
        </div>

        <div class="form-group">
          <label>Last Name:</label>
          <div class="input-group">
            <i class="fa-solid fa-user"></i>
            <input
              :value="doctor.lastname"
              @input="updateField('lastname', $event.target.value)"
              type="text"
              placeholder="Enter last name"
            />
          </div>
          <p v-if="errors.lastname" class="error">
            {{ errors.lastname }}
          </p>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Email:</label>
          <div class="input-group">
            <i class="fa-solid fa-envelope"></i>
            <input
              :value="doctor.email"
              @input="updateField('email', this.lowercaseStr($event.target.value))"
              type="email"
              placeholder="Enter Email"
            />
          </div>
          <p v-if="errors.email" class="error">
            {{ errors.email }}
          </p>
        </div>

        <div class="form-group">
          <label>Doctor Speciality:</label>
          <div class="input-group">
            <i class="fa-solid fa-stethoscope"></i>
            <input
              :value="doctor.speciality"
              @input="updateField('speciality', $event.target.value)"
              type="text"
              placeholder="Enter speciality"
            />
          </div>
          <p v-if="errors.speciality" class="error">
            {{ errors.speciality }}
          </p>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Department Code:</label>
          <div class="input-group">
            <i class="fa-solid fa-building"></i>
            <input
              :value="doctor.departmentCode"
              @input="updateField('departmentCode', $event.target.value)"
              type="text"
              placeholder="Enter department code"
            />
          </div>
          <p v-if="errors.departmentCode" class="error">
            {{ errors.departmentCode }}
          </p>
        </div>

        <div class="form-group">
          <label>Experience Years:</label>
          <div class="input-group">
            <i class="fa-solid fa-calendar"></i>
            <input
              :value="doctor.experienceYears"
              @input="updateField('experienceYears', $event.target.value)"
              type="number"
              placeholder="Enter Experience"
              step="1"
              min="0"
            />
          </div>
          <p v-if="errors.experienceYears" class="error">
            {{ errors.experienceYears }}
          </p>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Gender:</label>
          <div class="input-group">
            <i class="fa-solid fa-venus-mars"></i>
            <select
              :value="doctor.gender"
              @change="updateField('gender', $event.target.value)"
              class="form-control"
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
          <p v-if="errors.gender" class="error">
            {{ errors.gender }}
          </p>
        </div>
        <div class="form-group">
          <label>Phone Number:</label>
          <div class="input-group">
            <i class="fa-solid fa-phone"></i>
            <input
              :value="doctor.phone"
              @input="handlePhoneInput($event.target.value)"
              type="text"
              :placeholder="phonePlaceholder"
              minlength="10"
              maxlength="16"
            />
          </div>
          <p v-if="localPhoneError" class="error">{{ localPhoneError }}</p>
          <p v-else-if="errors.phone" class="error">{{ errors.phone }}</p>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Languages:</label>
          <div class="input-group">
            <i class="fa-solid fa-language"></i>
            <Multiselect
              v-model="localLanguages"
              :options="languageOptions"
              :multiple="true"
              :close-on-select="false"
              placeholder="Select languages"
            />
          </div>
          <p v-if="errors.languagesSpoken" class="error">
            {{ errors.languagesSpoken }}
          </p>
        </div>
        <div class="form-group">
          <label>Education / Degree:</label>
          <div class="input-group">
            <i class="fa-solid fa-stethoscope"></i>
            <input
              :value="doctor.medicalDegree"
              @input="updateField('medicalDegree', $event.target.value)"
              type="text"
              placeholder="Enter Your latest degree"
            />
          </div>
          <p v-if="errors.medicalDegree" class="error">
            {{ errors.medicalDegree }}
          </p>
        </div>
      </div>
      <div class="form-group full-width">
        <label>About:</label>
        <div class="input-group">
          <textarea
            :value="doctor.aboutMe"
            @input="updateField('aboutMe', $event.target.value)"
            placeholder="Enter About"
          ></textarea>
        </div>
        <p v-if="errors.aboutMe" class="error">
          {{ errors.aboutMe }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { lowercaseString, validatePhone } from "@/utils/helpers";
import Multiselect from "vue-multiselect";

export default {
  name: "DoctorProfileForm",
  components: { Multiselect },
  props: {
    doctor: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    routeId: {
      type: String,
      default: "",
    },
  },
  emits: ["update:doctor"],
  data() {
    return {
      languageOptions: ["English", "Urdu", "Arabic", "German"],
      localPhoneError: '',
    };
  },
  computed: {
    localLanguages: {
      get() {
        return this.doctor.languagesSpoken || [];
      },
      set(value) {
        this.updateField("languagesSpoken", value);
      },
    },
    isCanadaHospital() {
      // return isCanadaHospital();
      return true;
    },
    phonePlaceholder() {
      return 'Enter phone number';
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit("update:doctor", {
        ...this.doctor,
        [field]: value,
      });
    },
    handlePhoneInput(value) {
      // Preserve a leading + (country code prefix), strip everything else non-digit
      const str = value.toString();
      const hasPlus = str.startsWith('+');
      const digits = str.replace(/\D/g, '');
      this.updateField('phone', hasPlus ? '+' + digits : digits);
      // Clear inline error while user is typing
      this.localPhoneError = '';
    },
    validatePhoneInline() {
      const result = validatePhone(this.doctor.phone);
      this.localPhoneError = result.valid ? '' : result.message;
    },
    lowercaseStr(value) {
      return lowercaseString(value)
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.form-grid {
  display: flex;
  flex-direction: column;
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.multiselect__tags {
  min-height: 53px !important;
}

.form-group {
  flex: 1;
}

.fa-solid {
  font-size: 27px !important;
}

.form-group.full-width {
  width: 100%;
}

.form-grid .form-group label {
  display: block;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 600;
}

.form-grid .input-group {
  display: flex;
  align-items: center;
  width: 100%;
}

.form-grid .input-group i {
  background-color: #3c78f9;
  color: #fff;
  padding: 12px;
  font-size: 18px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.form-grid .input-group input,
.form-grid .input-group select,
.form-grid .input-group textarea {
  flex: 1;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.form-grid .input-group .multiselect {
  flex: 1;
  padding: 3px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-grid .input-group textarea {
  min-height: 100px;
  resize: none;
}

.form-grid .error {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
